import { unlockOnGesture } from '@/pure/audioUnlock';

/** The one daily-goal fanfare element, unlocked on the first gesture anywhere in the app (Home may load later). */
const fanfare = new Audio('/sounds/goal.mp3');
unlockOnGesture(document, fanfare);

export default fanfare;
